// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__k5DED","row":"styles_row__17AKY"};